import { Component } from '@angular/core';
import { DialogSize, SharedModule } from '@aiwyn/shared';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-secure-link-completion-dialog',
  imports: [
    SharedModule,
    MatDialogClose,
  ],
  templateUrl: './secure-link-completion-dialog.component.html',
  styleUrls: ['./secure-link-completion-dialog.component.scss'],
})
export class SecureLinkCompletionDialogComponent {
  protected readonly DialogSize = DialogSize;
  protected readonly baseDataSelector = 'secure-link-completion-dialog';
}
